function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHr = function SvgHr(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 514 514",
    height: 58.68049982732216,
    width: 60.95951957295365,
    xmlSpace: "preserve",
    y: "0px",
    x: "0px",
    id: "Layer_1_1565754628951",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1731__1565754628951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_46__1565754628951"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448,344c-2.63,0-5.21,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07c0,2.64,1.07,5.21,2.93,7.07    c1.86,1.86,4.44,2.93,7.07,2.93c2.63,0,5.21-1.07,7.07-2.93S458,356.63,458,354c0-2.63-1.07-5.21-2.93-7.07    C453.21,345.07,450.63,344,448,344z",
    id: "XMLID_47__1565754628951",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.57,398c-2.63,0-5.21,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07c0,2.63,1.07,5.21,2.93,7.07    c1.86,1.86,4.44,2.93,7.07,2.93s5.21-1.07,7.07-2.93c1.86-1.86,2.93-4.44,2.93-7.07c0-2.63-1.07-5.21-2.93-7.07    C172.78,399.07,170.2,398,167.57,398z",
    id: "XMLID_62__1565754628951",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.95,235.322l-40.094-8.767c16.473-11.617,27.264-30.776,27.264-52.42v-22.987v-10.635v-2.393    C330.12,102.764,301.356,74,266,74s-64.12,28.764-64.12,64.12v2.393v10.635v22.987c0,21.618,10.765,40.758,27.205,52.378    l-40.073,8.791c-25.554,5.606-44.102,28.663-44.102,54.825v43.908c0,5.523,4.477,10,10,10h222.179c5.523,0,10-4.477,10-10v-43.882    C387.089,263.975,368.526,240.915,342.95,235.322z M221.88,138.12C221.88,113.792,241.672,94,266,94    c22.781,0,41.584,17.354,43.884,39.536l-20.903-12.28c-4.212-2.475-9.593-1.544-12.73,2.199    c-9.422,11.244-23.24,17.693-37.91,17.693H221.88v-0.635V138.12z M221.88,161.148h16.461c17.724,0,34.563-6.704,47.347-18.631    l24.432,14.354v17.264c0,24.328-19.792,44.12-44.12,44.12s-44.12-19.792-44.12-44.12V161.148z M279.465,236.821l-13.606,31.973    l-13.636-32.046c4.441,0.977,9.047,1.507,13.777,1.507C270.619,238.255,275.12,237.753,279.465,236.821z M367.089,324.037H164.911    v-33.908c0-16.84,11.938-31.681,28.387-35.29l41.055-9.006l22.304,52.416c1.57,3.689,5.192,6.084,9.202,6.084    c4.009,0,7.632-2.395,9.202-6.084l22.307-52.421l41.31,9.033c16.463,3.6,28.412,18.443,28.412,35.295V324.037z",
    id: "XMLID_74__1565754628951",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,398H207.569c-5.523,0-10,4.477-10,10s4.477,10,10,10H364c5.523,0,10-4.477,10-10    S369.523,398,364,398z",
    id: "XMLID_1121__1565754628951",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,0h-54H144H90C62.43,0,40,22.43,40,50v24H30C13.458,74,0,87.458,0,104s13.458,30,30,30h10v92H30    c-16.542,0-30,13.458-30,30s13.458,30,30,30h10v92H30c-16.542,0-30,13.458-30,30s13.458,30,30,30h10v24c0,27.57,22.43,50,50,50h54    h264h54c27.57,0,50-22.43,50-50V50C512,22.43,489.57,0,462,0z M20,104c0-5.514,4.486-10,10-10h40c5.514,0,10,4.486,10,10    s-4.486,10-10,10H30C24.486,114,20,109.514,20,104z M20,256c0-5.514,4.486-10,10-10h40c5.514,0,10,4.486,10,10s-4.486,10-10,10H30    C24.486,266,20,261.514,20,256z M20,408c0-5.514,4.486-10,10-10h40c5.514,0,10,4.486,10,10s-4.486,10-10,10H30    C24.486,418,20,413.514,20,408z M492,462c0,16.542-13.458,30-30,30h-14.027c6.292-8.363,10.027-18.753,10.027-30v-67.574    c0-5.523-4.477-10-10-10s-10,4.477-10,10V462c0,16.542-13.458,30-30,30H144H90c-16.542,0-30-13.458-30-30v-24h10    c16.542,0,30-13.458,30-30s-13.458-30-30-30H60v-92h10c16.542,0,30-13.458,30-30s-13.458-30-30-30H60v-92h10    c16.542,0,30-13.458,30-30S86.542,74,70,74H60V50c0-16.542,13.458-30,30-30h54h264c16.542,0,30,13.458,30,30v264    c0,5.523,4.477,10,10,10s10-4.477,10-10V50c0-11.247-3.735-21.637-10.027-30H462c16.542,0,30,13.458,30,30V462z",
    id: "XMLID_1124__1565754628951",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hr.89cc9cd7.svg";
export { ForwardRef as ReactComponent };